import { colors } from '@styles';
import { flexMixin, textMixin } from '@styles/mixins';
import { styled } from 'styled-components';
import { Select } from 'antd';
import { ReactNode } from 'react';

export const Wrapper = styled.div`
    ${flexMixin('column', 'flex-start', 'center')}
    width: 100%;
    top: 0;
    gap: 16px;
    background-color: ${colors.bgWhite};

    .ant-table-row {
        height: 14px !important;
        padding: 2px !important;
    }

    .ant-table-cell {
        height: 14px !important;
        padding: 2px !important;
    }

    .ant-table-tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '12px',
            fontWeight: 400,
        })};
        line-height: 12px;
        text-align: left;
        padding: 2px;
        height: 12px;
    }

    .ant-table-thead > tr > th {
        background-color: #9481cd40;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 13px;
        text-align: left;
    }

    .ant-pagination {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16px;
        text-align: left;
        margin: 0 !important;
        margin-top: 5px !important;
        padding: 10px;
        background: ${colors.cleanWhite};
        box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
        border-radius: 0 0 5px 5px;
    }
`;

export const HeaderWrapper = styled.div`
    width: 100%;
    ${flexMixin('row', 'space-between', 'center')}
    padding: 20px 0;
`;
export const Title = styled.div`
    ${textMixin({
        fontSize: '2rem',
        fontWeight: 600,
    })};
    line-height: 28px;
    display: flex;
    align-items: center;
    color: ${colors.grey};
`;
export const TableWrapper = styled.div`
    width: 100%;

    .ant-table-thead {
        height: 40px;
        background: rgba(148, 129, 205, 0.25);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px 5px 0 0;
    }
    .ant-table-thead > tr > th::before {
        content: none !important;
    }
    .ant-table-cell {
        border-right: none !important;
        border-left: none !important;
        font-size: 14px !important;
    }

    .ant-table-row .ant-table-cell {
        height: 40px !important;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        align-items: center;
        color: ${colors.grey};

        & svg {
            margin-top: 9px;
        }
    }

    & td.leftAlign {
        text-align: left !important;
        padding-left: 5px !important;
    }

    & th.headerCenter {
        text-align: center !important;
    }

    .ant-table-header {
        overflow: hidden !important;
        .ant-table-fixed {
            .ant-table-thead > tr > th {
                background: #fafafa;
                z-index: 3;
                box-shadow: 1px 0 0 0 #f0f0f0;
                &::after {
                    content: '';
                    position: absolute;
                    right: -1px;
                    top: 0;
                    bottom: 0;
                    width: 1px;
                    background: #f0f0f0;
                    z-index: 4;
                }
            }
        }
    }
    @media (max-width: 575px) {
        .ant-table-cell-fix-left {
            background: rgba(148, 129, 205, 1);
        }

        .ant-table-thead .ant-table-cell-fix-left {
            background: rgba(148, 129, 205, 1);
            border-right: none !important;
            width: 7%;
        }
    }
`;
export const Overlay = styled.div<{
    display: string;
}>`
    display: ${({ display }) => display};
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(1px);
`;
export const StyledAddButton = styled.div`
    ${flexMixin('row', 'center', 'center')}
    padding: 3px 25px;
    gap: 10px;
    cursor: pointer;
    background: ${colors.primaryBg};
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
    border-radius: 5px;

    flex: none;
    order: 0;
    flex-grow: 0;
    color: ${colors.cleanWhite};
    & svg {
        width: 20px;
        height: 20px;
        color: #8f8f8f;
    }
`;
export const FooterWrap = styled.div`
    ${flexMixin('row', 'flex-start', 'center')}
`;

export const ActionWrap = styled.div<{ children?: ReactNode }>`
    ${flexMixin('row', 'flex-start', 'center')}
    gap: 10px;
`;

export const StyledSelect = styled(Select)`
    box-sizing: border-box;
    ${flexMixin('row', 'center', 'center')}
    gap: 10px;
    width: 175px;
    height: 38px;
`;
export const StyledActionButton = styled.button`
    ${flexMixin('row', 'center', 'center')}
    padding: 5px 10px;
    gap: 10px;
    width: 98px;
    height: 38px;
    background: ${colors.primaryBg};
    border-radius: 5px;
    border: none;

    cursor: pointer;
    & span {
        width: 78px;
        height: 28px;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 500,
        })};
        line-height: 28px;
        display: flex;
        align-items: center;
        color: ${colors.bgWhite};
        flex: none;
        order: 0;
        flex-grow: 0;
    }
`;
